import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import store from '@/store'
import Qs from 'qs'
import Cookies from 'js-cookie'
import { MessageBox } from 'element-ui'
import { decryptAES } from './jsencrypt'

export const hostUrl = window.baseUrl
const TokenKey = 'Odps-Token'
const onlineKey = 'Odps-onlineKey'
const errorCode = {
  '401': '认证失败，无法访问系统资源',
  '403': '当前操作没有权限',
  '404': '访问资源不存在',
  'default': '系统未知错误，请反馈给管理员'
}
export function getToken () {
  return Cookies.get(TokenKey)
}
export function setToken (token) {
  return Cookies.set(TokenKey, token)
}
export function getOnlineKey () {
  return Cookies.get(onlineKey)
}
export function setOnlineKey (key) {
  return Cookies.set(onlineKey, key)
}
export function removeToken () {
  return Cookies.remove(TokenKey)
}
export function removeOnlineKey () {
  return Cookies.remove(onlineKey)
}

export function logout () {
  let protocol = window.location.protocol;
  let host = window.location.host;
  post('/odpsmanage/logout.osp').then(res => {
    removeToken()
    removeOnlineKey()
    let logout_url = 'https://authserver.nwupl.edu.cn/authserver/logout?service='+ encodeURI(protocol+'//'+host+'/login');
    window.location.href = logout_url
  })
}

const http = axios.create({
  timeout: 1000 * 60 * 30,
  baseURL: window.baseUrl,
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  const isToken = (config.headers || {}).isToken === false
  // if (getToken() && !isToken) {
  //   // config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  //   config.headers['token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  // }
  return config
}, error => {
  return Promise.reject(error)
})

sessionStorage.setItem("isMsg", "0")

/**
 * 响应拦截
 */
http.interceptors.response.use(res => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // 获取错误信息
  const message = errorCode[code] || res.data.msg || errorCode['default']
  if (code === "310000") {
    // MessageBox({
    //   showClose: false,
    //   showCancelButton: false,
    //   type: "warning",
    //   message: '登录状态已过期，需重新登录',
    // })
    router.push('/login')
    return Promise.reject('error')
  } //else if (code === 500) {
  //   MessageBox.confirm({
  //     message: message,
  //     type: 'error'
  //   })
  //   return Promise.reject(new Error(message))
  // } else if (code === 10 || code === 20) {
  //   return res.data
  // } else if (code !== 200) {
  //   console.log({
  //     title: message
  //   })
  //   return Promise.reject('error')
  // } else {
  //   if (res.data.yfJoinTableInfoFrontEnd && typeof res.data.yfJoinTableInfoFrontEnd === 'string') {
  //     let s = decryptAES(res.data.yfJoinTableInfoFrontEnd);
  //     res.data.yfJoinTableInfoFrontEnd = JSON.parse(s);
  //   }
  //   else if (res.data.yfJoinTableInfoFrontEnd && res.data.yfJoinTableInfoFrontEnd.table_data) {
  //     let table_data = res.data.yfJoinTableInfoFrontEnd.table_data;
  //     for (let i = 0; i < table_data.length; ++i) {
  //       let row = table_data[i];
  //       if (typeof row === 'string') {
  //         let s = decryptAES(row);
  //         let newRow = JSON.parse(s);
  //         table_data[i] = newRow;
  //       }
  //     }
  //   }
  // if (res.data.yfJoinTableInfoFrontEnd && res.data.yfJoinTableInfoFrontEnd.table_data) {
  //   console.log(res.data.yfJoinTableInfoFrontEnd.table_data)
  // }
  return res.data
}, error => {
  console.log('err' + error)
  if (error.message !== undefined) {
    console.log({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
  }
  return Promise.reject(error)
})

/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
http.adornUrl = (actionName) => {
  return window.baseUrl + actionName
}

function clearLoginInfo () {
  Vue.cookie.delete('token')
}
export default http

export function post (url, data) {
  return http(url, {
    method: 'post',
    data: data
  }).then(res => {
    return res
  })
}

export function get (url, params) {
  return http(url, {
    method: 'get',
    params: params
  }).then(res => {
    return res
  })
}

export function getTable (url, params) {
  return http(url, {
    method: 'get',
    params: params
  }).then(res => {
    return res
  })
}

export function put (url, params) {
  return http(url, {
    method: 'put',
    data: params
  }).then(res => {
    return res
  })
}

export function del (url, params) {
  return http(url, {
    method: 'delete',
    data: params
  }).then(res => {
    return res
  })
}

export function getSearch(searchOption) {
  if (searchOption.tplName && searchOption.conds) {
    let query = ""
    searchOption.conds.forEach(cond => {
      query += '<Condition Name="' + cond.name + '" Where="' + cond.where + '"/>'
    });
    let searchUrl = `/odpsmanage/getsearchresultv2.osp?SearchTplName=${searchOption.tplName}&_rtype=text`
    searchUrl = (query == "" ? searchUrl : `${searchUrl}&EncodeQuery=1&Query=${encode(`<Query>${query}</Query>`, true)}`)
    return http(searchUrl, {
      method: 'post',
    }).then(res => {
      return res
    })
  } else {
    console.error('参数异常！')
  }
}

export function getBrowser () {

  const u = navigator.userAgent;

  const bws = [{
    name: 'sgssapp',
    it: /sogousearch/i.test(u)
  }, {
    name: 'wechat',
    it: /MicroMessenger/i.test(u)
  }, {
    name: 'wechat',
    it: /WeChat/i.test(u)
  }, {
    name: 'wechat',
    it: /Weixin/i.test(u)
  }, {
    name: 'weibo',
    it: !!u.match(/Weibo/i)
  }, {
    name: 'uc',
    it: !!u.match(/UCBrowser/i) || u.indexOf(' UBrowser') > -1
  }, {
    name: 'sogou',
    it: u.indexOf('MetaSr') > -1 || u.indexOf('Sogou') > -1
  }, {
    name: 'xiaomi',
    it: u.indexOf('MiuiBrowser') > -1
  }, {
    name: 'baidu',
    it: u.indexOf('Baidu') > -1 || u.indexOf('BIDUBrowser') > -1
  }, {
    name: '360',
    it: u.indexOf('360EE') > -1 || u.indexOf('360SE') > -1
  }, {
    name: '2345',
    it: u.indexOf('2345Explorer') > -1
  }, {
    name: 'edge',
    it: u.indexOf('Edg') > -1
  }, {
    name: 'ie11',
    it: u.indexOf('Trident') > -1 && u.indexOf('rv:11.0') > -1
  }, {
    name: 'ie',
    it: u.indexOf('compatible') > -1 && u.indexOf('MSIE') > -1
  }, {
    name: 'firefox',
    it: u.indexOf('Firefox') > -1
  }, {
    name: 'safari',
    it: u.indexOf('Safari') > -1 && u.indexOf('Chrome') === -1
  }, {
    name: 'qqbrowser',
    it: u.indexOf('MQQBrowser') > -1 && u.indexOf(' QQ') === -1
  }, {
    name: 'qq',
    it: u.indexOf('QQ') > -1
  }, {
    name: 'chrome',
    it: u.indexOf('Chrome') > -1 || u.indexOf('CriOS') > -1
  }, {
    name: 'opera',
    it: u.indexOf('Opera') > -1 || u.indexOf('OPR') > -1
  }];

  for (var i = 0; i < bws.length; i++) {
    if (bws[i].it) {
      return bws[i].name;
    }
  }

  return 'other';
}